export default __webpack_public_path__ + "static/media/black_knight.494fb15c.png";